import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import { AccountApiClient } from '../../api/account-api-client';

export const setAccountStatus = (
  accountId: number,
  status: AccountStatus,
  extraInfo: Record<string, any>,
) =>
  createGenericDispatcher({
    name: 'SET_ACCOUNT_STATUS',
    loadFunction: () => new AccountApiClient(accountId).setStatus(status, extraInfo),
    args: {
      accountId,
      status,
      extraInfo,
    },
    onSuccess: (dispatch, getState, data) => {
      const { salesforceErrors } = data;
      if (salesforceErrors) {
        dispatch(
          addNotificationAction({
            key: `salesforce-trial-info-update-error-${accountId}`,
            className: 'u-width-500px',
            message:
              'Something went wrong while updating the associated opportunity in Salesforce. Please update Salesforce manually.',
          }),
        );
      }
    },
  });
